import {get} from '../utils'
import {includeQuery} from './utils';
import {getActiveChannel, getActiveClient, getStoredUser} from "../authentication/utils";
import localization from '../../../config/localization';

export default host => (id, include = includeQuery) =>
  get(`${host}/clients/${getActiveClient()}/${getActiveChannel() ? `channels/${getActiveChannel()}/` : ""}contentCreators/${id}?${include}${!getStoredUser() ? "&l1=1" : "&l2=1"}${getActiveChannel() ? `&cLang=${localization.getLanguage()}` : ""}`)
    .then(response => response.json())
    .then(json => json.data)
